import React, { useEffect, useMemo } from 'react';
import {
	createRecordPathCodec,
	NavbarType,
	QuickbaseIFrameContainer,
	quickbaseNavbarStoreSelector,
	recordPathSegmentFor,
	recordPresentationFor,
	useDashboardStore,
	useQuickbaseHostBridgeSync,
} from '@warehouse/quickbase';
import styled, { css } from 'styled-components';
import Card from '../../components/library/Card';

export function DashboardQuickbase() {
	const isLoading = useDashboardStore(quickbaseNavbarStoreSelector.isLoading);
	const isAuthenticated = useDashboardStore(quickbaseNavbarStoreSelector.isAuthenticated);
	const error = useDashboardStore(quickbaseNavbarStoreSelector.error);
	const embedUrl = useDashboardStore(quickbaseNavbarStoreSelector.embedUrl);
	const frameUrl = useDashboardStore(quickbaseNavbarStoreSelector.frameUrl);
	const showAuthOverlay = useDashboardStore(quickbaseNavbarStoreSelector.showAuthOverlay);
	const authFlow = useDashboardStore(quickbaseNavbarStoreSelector.authFlow);
	const actions = useDashboardStore(quickbaseNavbarStoreSelector.actions);
	const { loadEmbedUrl, authenticate, setShowAuthOverlay, dismissAuthOverlay, recoverSession } = actions;

	const codec = useMemo(
		() =>
			createRecordPathCodec({
				resolveBasePath: () => '/dashboard',
				recordSegment: recordPathSegmentFor(NavbarType.Dashboard),
			}),
		[],
	);

	const { bridge, initialEmbedParams, reloadToken } = useQuickbaseHostBridgeSync({
		embedUrl,
		codec,
		reloadEmbedUrl: loadEmbedUrl,
		presentation: recordPresentationFor(NavbarType.Dashboard),
	});

	useEffect(() => {
		loadEmbedUrl(initialEmbedParams);
	}, [loadEmbedUrl, initialEmbedParams]);

	return (
		<Wrapper>
			<CardWrapper>
				<Card sx={{ minWidth: 275, overflow: 'hidden', height: '100%' }}>
					<QuickbaseIFrameContainer
						isLoading={isLoading}
						isAuthenticated={isAuthenticated}
						error={error}
						embedUrl={embedUrl}
						frameUrl={frameUrl}
						showAuthOverlay={showAuthOverlay}
						authenticate={authenticate}
						setShowAuthOverlay={setShowAuthOverlay}
						dismissAuthOverlay={dismissAuthOverlay}
						recoverSession={recoverSession}
						authFlow={authFlow}
						iFrameType="Dashboard"
						bridge={bridge}
						reloadToken={reloadToken}
					/>
				</Card>
			</CardWrapper>
		</Wrapper>
	);
}
// Styled components
const Wrapper = styled.div(
	() => css`
		background-color: #dde0e3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		width: 100%;
	`,
);

const CardWrapper = styled.div(
	({ theme }) => css`
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		gap: ${theme.spacing(2)};
		padding: ${theme.spacing(2)};
		width: 100%;
	`,
);
